import { AdjustableNumber, AdjustableNumberColumn } from "components/generic/AdjustableNumber";
import styled from "styled-components";
import { WidgetPixelPosition } from "types/Widget";

interface Props {
  time: Date;
  setTime: (time: Date) => void;
  position: WidgetPixelPosition;
  is24Hour: boolean;
  showSeconds: boolean;
}

const twentyFourHourClockColumns = (showSeconds: boolean): Array<AdjustableNumberColumn> => [
  { maxValue: 24, adjustRemaining: (val) => val % 24 },
  { text: ":" },
  { maxValue: 60 },
  { text: ":", isHidden: !showSeconds },
  { maxValue: 60, isHidden: !showSeconds },
];

const twelveHourClockColumns = (showSeconds: boolean): Array<AdjustableNumberColumn> => [
  { maxValue: 24, adjustRemaining: (val) => (val === 0 || val === 12 ? 12 : val % 12) },
  { text: ":" },
  { maxValue: 60 },
  { text: ":", isHidden: !showSeconds },
  { maxValue: 60, isHidden: !showSeconds },
  {
    getText: (val, max) => (val < max / 2 ? "AM" : "PM"),
    adjustBy: (max) => max / 2,
  },
];

export const DigitalClock: React.FC<Props> = ({ time, setTime, is24Hour, showSeconds }) => {
  const value = time.getSeconds() + time.getMinutes() * 60 + time.getHours() * 3600;

  return (
    <OuterContainer>
      <AdjustableNumber
        value={value}
        columns={
          is24Hour ? twentyFourHourClockColumns(showSeconds) : twelveHourClockColumns(showSeconds)
        }
        setValue={(newVal) =>
          setTime(
            new Date(
              0,
              0,
              0,
              Math.floor(newVal / 3600),
              Math.floor((newVal % 3600) / 60),
              newVal % 60,
            ),
          )
        }
        onValueIsOver={(val, maxVal) => val % maxVal}
        onValueIsNegative={(val, maxVal) => val + maxVal}
      />
    </OuterContainer>
  );
};

const OuterContainer = styled.div`
  width: 90%;
  position: relative;
`;
